<template>
  <b-modal
    v-model="visible"
    :title="`Thêm vào nhóm chia sẻ${entityLabel ? ': ' + entityLabel : ''}`"
    hide-footer
    centered
    @hidden="record = null"
  >
    <p class="text-muted mb-3">
      Chọn thư mục muốn thêm bản ghi này vào. Dữ liệu sẽ được chia sẻ tới các
      công ty đã thiết lập trong nhóm.
    </p>
    <div v-if="loading" class="text-center p-3">
      <i class="fa fa-spinner fa-spin" /> Đang tải nhóm chia sẻ
    </div>
    <div v-else-if="groups.length" class="sharing-group-list">
      <button
        v-for="group in groups"
        :key="group.id"
        type="button"
        class="btn btn-light border w-100 text-left d-flex align-items-center mb-2 p-2"
        :disabled="saving"
        @click="share(group)"
      >
        <i class="fa fa-folder-open text-warning font-22 mr-2" />
        <span class="flex-fill">
          <span class="d-block font-weight-bold">{{ group.name }}</span>
          <small class="text-muted">{{ sharedTo(group) }}</small>
        </span>
        <i v-if="savingGroupId === group.id" class="fa fa-spinner fa-spin" />
        <i v-else class="fa fa-plus text-primary" />
      </button>
    </div>
    <div v-else class="text-center text-muted p-3">
      Chưa có nhóm chia sẻ nào được bật cho loại dữ liệu này.
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "SharingGroupPicker",
  props: {
    entityType: { type: String, required: true },
    entityLabel: { type: String, default: "" },
  },
  data: () => ({
    visible: false,
    loading: false,
    savingGroupId: null,
    record: null,
    groups: [],
  }),
  computed: {
    saving() {
      return this.savingGroupId !== null
    },
  },
  methods: {
    open(record) {
      this.record = record
      this.visible = true
      this.load()
    },
    load() {
      this.loading = true
      return this.$api
        .myOwnedSharingGroups()
        .then((groups) => {
          this.groups = (groups || []).filter((group) =>
            (group.sharedEntityTypes || []).includes(this.entityType),
          )
        })
        .finally(() => {
          this.loading = false
        })
    },
    sharedTo(group) {
      // Group name là nhãn mà admin đặt cho các công ty nhận chia sẻ.
      return `Chia sẻ tới: ${group.name}`
    },
    share(group) {
      if (!this.record || this.saving) return
      this.savingGroupId = group.id
      this.$api
        .shareRecords(group.id, this.entityType, [this.record.id])
        .then(() => {
          this.$noti.open(`Đã thêm vào nhóm “${group.name}”`)
          this.visible = false
          this.$emit("shared", { group, record: this.record })
        })
        .finally(() => {
          this.savingGroupId = null
        })
    },
  },
}
</script>
